import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { BREAKPOINTS } from 'utils/styled'

export const SGridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(18rem, 1fr));
  grid-gap: 1.5rem;

  @media ${BREAKPOINTS.MD.max} {
    grid-gap: 1rem;
  }
`

export const highlightedParagraphCss = css`
  p {
    font-size: 1.25em !important;
    line-height: 150% !important;
    margin-top: 0.5rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    grid-template-columns: 1fr;

    & > span > :last-child {
      position: absolute;
      right: 1rem;
      bottom: 1rem;
    }
  }
`
